var map = {
	"./bgDecoration.png": 7416,
	"./photoDownDesktop.png": 9918,
	"./photoDownMobile.png": 1007,
	"./photoDownTablet.png": 5337,
	"./photoUpDesktop.png": 8086,
	"./photoUpMobile.png": 1313,
	"./photoUpTablet.png": 937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2730;